import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import { focusStyle } from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Focus";
import { AvailabilityBadges } from "../../../../../../../common-deprecated/components/aem/toyota/availability-badges/styles/AvailabilityBadgesStyles";
import InternalLink from "../../../../../../../common-deprecated/components/styles/InternalLinkStyles";

export const Results = styled.div`
    width: 100%;
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-auto-rows: 1fr;
    width: 100%;

    ${InternalLink} {
        height: 100%;
        padding: 0;
        border: none;
    }

    @media ${getBreakpoint("up", "md")} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-column: 1 / span 4;
    }

    @media ${getBreakpoint("up", "lg")} {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        grid-column: 2 / span 5;
    }
`;

export const Container = styled.div<SpaceProps>`
    position: relative;
    ${space}
    @media ${getBreakpoint("down", "lg")} {
        padding-top: ${theme.space[3]}px;
        border-top: 1px solid ${theme.colors.grey2};
    }
`;

export const LegalBannerContainer = styled(Container)`
    max-width: 1440px;
    margin: 0 auto;
    padding: 40px 16px;
    @media ${getBreakpoint("up", "lg")} {
        padding: 80px 40px;
    }
`;

export const Wrapper = styled.article<{ hasRightBorder?: boolean }>`
    display: flex;
    position: relative;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space[5]}px ${theme.space[3]}px;

    @media ${getBreakpoint("up", "md")} {
        border-bottom: 1px solid ${theme.colors.grey2};
        border-right: 1px solid ${theme.colors.grey2};
        &:nth-child(2n) {
            border-right: 1px solid ${theme.colors.grey2};
        }
    }

    @media ${getBreakpoint("up", "xl")} {
        &:nth-child(1n) {
            border-right: 1px solid ${theme.colors.grey2};
        }
    }

    a {
        text-align: center;
    }

    ${Button.ButtonTertiary} {
        margin-top: auto;
        margin-bottom: ${theme.space[3] / 2}px;
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "md")} {
            border-left: 1px solid ${theme.colors.grey2};
            border-right: none;
        }
        @media ${getBreakpoint("only", "md")} {
            /* 2nd column */
            &:nth-child(3n - 1) {
                border-left: none;
            }
        }
        @media ${getBreakpoint("up", "xl")} {
            /* 1st column */
            &:nth-child(3n - 2) {
                border-left: 1px solid ${theme.colors.grey2};
                border-right: none;
            }

            /* 3rd column */
            &:nth-child(3n) {
                border-left: none;
                border-right: 1px solid ${theme.colors.grey2};
            }
        }
    }
`;

export const Header = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    width: 100%;

    @media ${getBreakpoint("up", "md")} {
        margin-bottom: ${theme.space[3]}px;
    }

    ${AvailabilityBadges} {
        > ul {
            > li {
                width: 100%;
                text-align: center;
            }
        }
    }
`;

export const BadgesWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: ${theme.space[1]}px;
    width: 100%;

    &:not(:empty) {
        margin-top: ${theme.space[1]}px;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
`;

export const ImageWrapper = styled.div`
    margin-top: auto;
`;

export const RedirectWrapper = styled.a`
    &:hover {
        color: unset;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0 ${theme.space[3]}px;
`;

export const Main = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    @media ${getBreakpoint("up", "lg")} {
        flex-wrap: nowrap;
    }
`;

export const MainGrid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    justify-content: center;

    @media ${getBreakpoint("up", "md")} {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media ${getBreakpoint("up", "lg")} {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
`;

export const Title = styled.h2`
    &,
    a {
        margin-bottom: ${theme.space[1]}px;
        font-family: ${theme.fonts.regular};
        font-size: 2.2rem;
        line-height: 2.8rem;
        text-transform: none;
    }
`;

export const GRLogo = styled.div`
    width: 50px;
`;

export const EcoBadgeWrapper = styled.div`
    display: flex;
    position: absolute;
    bottom: -4.5rem;
    right: 0;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-block-start: 1rem;
`;

export const GradesLink = styled(Button.Link)`
    display: flex;
    margin-bottom: 0;
    color: ${theme.colors.primaryBlack};

    ${focusStyle};
`;

export const Eta = styled.div`
    display: flex;
    align-items: center;
    gap: calc(${theme.space[1]}px / 2);
    margin: 0;
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
    color: ${theme.colors.grey7};

    p:first-child {
        margin: 0;
    }
`;

export const DisclaimerIcon = styled.span`
    display: flex;
    align-items: center;
    color: ${theme.colors.grey7};
    cursor: pointer;
`;
